module.exports = __webpack_public_path__ + "img/collective_management_item_bg1.6e1710d5.png";